"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PATIENT_PERMISSIONS = exports.PatientPermissions = void 0;
/**
 * Permission string catalog for the Patient Identity bounded context
 * (Stage 4C.5). Format: `<module>:<action>`, same convention as
 * `platform.permissions.ts`/`master-data.permissions.ts`. Added now,
 * additively — no permission catalog existed for Patient Identity
 * before this stage, since nothing needed RBAC gating until an HTTP
 * layer existed to gate. This file adds no new business rule; every
 * permission here gates a workflow whose rule already lives inside a
 * frozen Domain Service (Stage 4C.2).
 *
 * One permission per REST resource group, not per individual
 * operation — `patient:register` covers all 6 registration variants,
 * `patient:protection:manage` covers apply/release/remove, etc. — the
 * same "collapse micro-actions into one permission" convention
 * `master-data.permissions.ts` already established for administrative
 * bulk actions, applied here to Patient Identity's own operation
 * groupings.
 */
exports.PatientPermissions = {
    PATIENT_REGISTER: 'patient:register',
    PATIENT_SEARCH: 'patient:search',
    PATIENT_TIMELINE_READ: 'patient:timeline:read',
    PATIENT_COVERAGE_MANAGE: 'patient:coverage:manage',
    PATIENT_CONSENT_MANAGE: 'patient:consent:manage',
    PATIENT_MERGE: 'patient:merge',
    PATIENT_PROTECTION_MANAGE: 'patient:protection:manage',
    PATIENT_IDENTITY_RESOLUTION_MANAGE: 'patient:identity-resolution:manage',
    // Enterprise Architecture Handbook v1.0, Part IV.4 (Duplicate Detection
    // Foundation) — separate from PATIENT_IDENTITY_RESOLUTION_MANAGE (which
    // gates *acting* on a candidate) since editing the scoring weights/tier
    // thresholds is a materially higher-impact, admin-only action.
    PATIENT_DUPLICATE_DETECTION_CONFIG_MANAGE: 'patient:duplicate-detection-config:manage',
    // Enterprise Configurable Patient Registration (ADR-034) — homed here,
    // not platform.permissions.ts, because the *workflow* being gated
    // (configuring the patient registration form) is patient-domain
    // specific, the same reasoning that already placed
    // PATIENT_PROTECTION_MANAGE here despite RecordProtection itself
    // being an entity-agnostic mechanism.
    PATIENT_REGISTRATION_CONFIGURATION_VIEW: 'patient:registration-configuration:view',
    PATIENT_REGISTRATION_CONFIGURATION_EDIT: 'patient:registration-configuration:edit',
    PATIENT_REGISTRATION_CONFIGURATION_PUBLISH: 'patient:registration-configuration:publish',
};
/** Every Patient Identity permission, flattened — used to seed the `permissions` table. */
exports.ALL_PATIENT_PERMISSIONS = Object.values(exports.PatientPermissions);
//# sourceMappingURL=patient.permissions.js.map